const doc = [({"en":({"js":({"admin":({"economy":({"dimensions":({"index":({"locked_dimensions":"Locked dimensions"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;